<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Répartition des charges mensuelles</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_charges_mens.png" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <div echarts [options]="options" [merge]="data" class="chart"></div>
        </div>
    </div>
</div>
